<div class="modal-body">
  <form [formGroup]="formFilter" (ngSubmit)="applyFilters()">

    <!-- URL Label Control -->
    <div class="form-group">
      <label for="label">Link text</label>
      <input type="text" class="form-control" [formControl]="label" id="label" placeholder="Paste link text, max 30 characters" maxlength="30"/>

      <div *ngIf="label.errors && (label.dirty || label.touched)">
        <div *ngIf="label.errors.required" class="invalid-feedback force-show">
          This field is required.
        </div>
        <div *ngIf="label.errors.maxLength" class="invalid-feedback force-show">
          This field should not contain more than 30 characters.
        </div>
      </div>
    </div>
    <!-- URL Label Control -->

    <!-- URL Label Control -->
    <div class="form-group">
      <label for="label">URL Link</label>
      <input type="text" class="form-control" [formControl]="url" id="url" placeholder="Past URL Link..."/>

      <div *ngIf="url.errors && (url.dirty || url.touched)">
        <div *ngIf="url.errors.required" class="invalid-feedback force-show">
          This field is required.
        </div>
        <div *ngIf="url.errors.pattern" class="invalid-feedback force-show">
          This field should be a valid URL.
        </div>
      </div>
    </div>
    <!-- URL Label Control -->

    <div class="form-group">
      <button
        type="submit"
        class="btn btn-outline-success mr-auto"
        [disabled]="formFilter.invalid || !changed()">Save</button>
    </div>
  </form>
</div>
